import Api from "@/services/Api";

export default {
	async loginRoute(user, password) {
		return Api()
			.post("login", { user, password })
			.then(response => response.data);
	},

	async getMailRoute(user) {
		return Api().get("get-mail", {
			params: {
				user
			}
		});
	},

	async verifyRoute(token) {
		Api().defaults.headers.common["Authorization"] = "Bearer " + token;

		return Api()
			.get(rootUrl + "verify")
			.then(response => response.data);
	},

	fetchFeatureMessages() {
		return Api().get("messages/feature/list");
	},

	fetchZpravyMessages() {
		return Api().get("messages/zpravy/list");
	},

	fetchStats() {
		return Api().get("messages/stats/list");
	},

	addFeatureMessage(msg) {
		return Api().get("messages/feature/add", {
			params: {
				msg
			}
		});
	},

	addZpravaMessage(msg) {
		return Api().get("messages/zprava/add", {
			params: {
				msg
			}
		});
	},

	fetchDownloadedZipped() {
		return Api().get("adresni-databaze/zipped");
	},

	fetchDownloadedUnzipped() {
		return Api().get("adresni-databaze/unzipped");
	},

	downloadZalohuDb(id) {
		return Api().get("adresni-databaze/download", {
			params: {
				id
			}
		});
	},

	unzipZalohuDb(d) {
		return Api().get("adresni-databaze/unzip", {
			params: {
				d
			}
		});
	},

	checkStatus() {
		return Api().get("adresni-databaze/status");
	},

	nahrajDatabazi(d) {
		return Api().get("adresni-databaze/update", {
			params: {
				d
			}
		});
	},

	fetchActivityLogs() {
		return Api().get("activity/logs/fetch");
	},

	fetchApiActivityLogs() {
		return Api().get("activity/api/fetch");
	},

	fetchUpgradeActivityLogs() {
		return Api().get("activity/upgrade/logs/fetch");
	},

	fetchRecentUserActivity() {
		return Api().get("activity/users/recent");
	},

	/**
	 * Search Provider
	 */

	/**
	 * Nabidky pro jednotlive adresni misto.
	 * @param { String } am - adresni misto.
	 */
	queryOffers(am) {
		return Api().get("provider/offers", {
			params: {
				am
			}
		});
	},

	/**
	 * Druhej hit je string s mezerou.
	 * @param { String } string - jmeno ulice s cislem popisnym.
	 */
	secondHit(string, user) {
		// if (! isNaN(string)) {
		// 	return Api().get('address/products', {
		// 		params: {
		// 			adresniMisto: string,
		// 		}
		// 	})
		// }
		return Api().get("provider/second", {
			params: {
				string,
				user
			}
		});
	},

	/**
	 * Prvni hit je string bez mezery.
	 * @param { String } string pravdepodobne jenom jmeno ulice, je to bez mezery.
	 */
	// firstHit (string) {
	// 	return Api().get('provider/first', {
	// 		params: {
	// 			string,
	// 		}
	// 	})
	// },

	/**
	 * Search Engine
	 */

	/**
	 * Vrat vsechny jmena mesta podle substringu
	 */

	fetchCityNames(citySearchPhrase) {
		return Api().get("city/substr", {
			params: citySearchPhrase
		});
	},

	fetchStreetNames(streetSearchPhrase, cityName) {
		return Api().get("street/substr", {
			params: {
				streetSearchPhrase,
				cityName
			}
		});
	},

	streetNameExists(streetSearchPhrase, cityName) {
		return Api().get("street/exists", {
			params: {
				streetSearchPhrase,
				cityName
			}
		});
	},

	addressNameExists(
		streetName,
		cityName,
		addressSearchPhrase,
		addressSearchPhraseTwo,
		addressSearchPhraseThree,
		popNeboEv,
		addressAddingCityPart
	) {
		return Api().get("address/exists", {
			params: {
				streetName,
				cityName,
				addressSearchPhrase,
				addressSearchPhraseTwo,
				addressSearchPhraseThree,
				popNeboEv,
				addressAddingCityPart
			}
		});
	},

	fetchProducts(adresniMisto, user) {
		return Api().get("address/products", {
			params: {
				adresniMisto,
				user
			}
		});
	},

	fetchInfoData(adresniMisto, user) {
		return Api().get("address/products/info", {
			params: {
				adresniMisto,
				user
			}
		});
	},

	fetchApiData(adresniMisto) {
		return Api().get("/address/api", {
			params: {
				adresniMisto
			}
		});
	},

	fetchNejpripoData(adresniMisto, user) {
		return Api().get("/address/products/nejpripo", {
			params: {
				adresniMisto,
				user
			}
		});
	},
	fetchOrelSoftAvailability(adresniMisto, user) {
		return Api().get("/address/products/orelsoft", {
			params: {
				adresniMisto,
				user
			}
		});
	},
	fetchStarnetProducts(adresniMisto, user) {
		return Api().get("address/products/starnet", {
			params: {
				adresniMisto,
				user
			}
		});
	},

	fetchCetinProducts(adresniMisto, user) {
		return Api().get("address/products/cetin", {
			params: {
				adresniMisto,
				user
			}
		});
	},

	fetchUVTAvailability(adresniMisto, user) {
		return Api().get("address/products/uvt", {
			params: {
				adresniMisto,
				user
			}
		});
	},

	fetchTlapkaAvailability(adresniMisto, user) {
		return Api().get("address/products/tlapka", {
			params: {
				adresniMisto,
				user
			}
		});
	},

	fetchVodafoneData(adresniMisto, user) {
		return Api().get("address/products/vodafone", {
			params: {
				adresniMisto,
				user
			}
		});
	},

	fetchSprintelProducts(adresniMisto, user) {
		return Api().get("address/products/sprintel", {
			params: {
				adresniMisto,
				user
			}
		});
	},

	fetchNordicProducts(adresniMisto, user) {
		return Api().get("address/products/nordic", {
			params: {
				adresniMisto,
				user
			}
		});
	},

	fetchDluzniciProducts(adresniMisto, user) {
		return Api().get("address/products/dluznici", {
			params: {
				adresniMisto,
				user
			}
		});
	},

	fetchAddressCoords(adresniMisto, user) {
		return Api().get("address/map/coords", {
			params: {
				adresniMisto,
				user
			}
		});
	},

	addNewProduct(adresniMisto, newProduct) {
		return Api().post("address/product/add", {
			data: {
				adresniMisto,
				newProduct
			}
		});
	},

	updateProduct(product) {
		return Api().post("address/product/edit", {
			data: {
				product
			}
		});
	},

	deleteProduct(index) {
		return Api().get("address/product/remove", {
			params: {
				index
			}
		});
	},

	saveAdresniPoznamka(adresniMisto, text) {
		return Api().get("address/poznamka/edit", {
			params: {
				adresniMisto,
				text
			}
		});
	},

	saveMestaBezdrat(cityName, text) {
		return Api().get("address/bezdrat/edit", {
			params: {
				cityName,
				text
			}
		});
	},

	saveUlicePoznamka(text, cityName, streetName) {
		return Api().get("street/poznamka/edit", {
			params: {
				text,
				cityName,
				streetName
			}
		});
	},

	fetchAddressNames(addressSearchPhrase, cityName, streetName) {
		return Api().get("address/substr", {
			params: {
				addressSearchPhrase,
				streetName,
				cityName
			}
		});
	},

	deleteAddressName(index) {
		return Api().get("address/delete", {
			params: {
				index
			}
		});
	},

	/**
	 * Vyhledavej mesto podle psc.
	 */
	searchCityByPsc(psc) {
		return Api().get("city/psc", {
			params: {
				psc: psc
			}
		});
	},

	/**
	 * Vyhledavej mesto podle jmena.
	 */
	searchCityByName(name) {
		return Api().get("city/name", {
			params: {
				name: name
			}
		});
	},

	/**
	 * Vyhledavej ulici podle substringu.
	 */
	searchStreetsBySubstring({ name, district, substring }) {
		return Api().get("city/streets", {
			params: {
				name,
				district,
				substring
			}
		});
	},

	/**
	 * Pridavani jednotlivych adresnich mist i s ulicí.
	 * @param { String } mesto
	 * @param { String } ulice
	 * @param { Array } adresy
	 */
	addNewAddress(mesto, ulice, adresy) {
		return Api().post("ulice/add", {
			data: {
				mesto,
				ulice,
				adresy
			}
		});
	},

	/**
	 * Pridavani samostatneho adresniho mista do ulice.
	 * @param {*} mesto
	 * @param {*} domovni
	 * @param {*} orientacni
	 * @param {*} ulice
	 */
	addNewAdresniMisto(mesto, domovni, orientacni, ulice) {
		return Api().post("adresa/add", {
			data: {
				mesto,
				domovni,
				orientacni,
				ulice
			}
		});
	},

	/**
	 * Pridavani textu k ulici.
	 */
	addStreetText(text, ulice, mesto) {
		return Api().post("adresa/text/add", {
			data: {
				text,
				ulice,
				mesto
			}
		});
	},

	/**
	 * Pridavani textu k jednotlivemu adresnimu mistu.
	 */
	adresniMistoTextAdd(obj) {
		return Api().post("adresa/misto/text/add", {
			data: {
				obj
			}
		});
	},

	/**
	 * User stuff
	 */

	/**
	 * Smazat usera.
	 */
	deleteUser(name) {
		return Api().get("users/delete", {
			params: {
				name
			}
		});
	},

	/**
	 * Uloz pravomoce.
	 */
	savePowers(name, powers) {
		return Api().get("powers/save", {
			params: {
				name,
				powers
			}
		});
	},

	/**
	 * Get pravomoce.
	 */
	fetchPowers() {
		return Api().get("powers");
	},

	/**
	 * get Usery.
	 */
	fetchUsers() {
		return Api().get("users");
	},

	fetchUsersPoskytovatele() {
		return Api().get("users/poskytovatele");
	},

	addToZakazano(spolecnost, id) {
		return Api().get("users/zakazano/add", {
			params: {
				spolecnost,
				id
			}
		});
	},

	removeFromZakazano(spolecnost, id) {
		return Api().get("users/zakazano/remove", {
			params: {
				spolecnost,
				id
			}
		});
	},

	/**
	 * Pridat noveho usera.
	 */
	addNewUser(name, pswd, mail) {
		return Api().get("users/add", {
			params: {
				name,
				pswd,
				mail
			}
		});
	},

	/**
	 * Změna hesla usera.
	 */
	changePassword(id, pswd) {
		return Api().get("users/pswd/change", {
			params: {
				id,
				pswd
			}
		});
	},
	/**
	 * Zmenit status userovi.
	 */
	changeUserStatus(id) {
		return Api().get("users/change-status", {
			params: {
				id
			}
		});
	},

	/**
	 * Prace s obrazkovou mapou
	 */

	sendImageWithCoords(myData) {
		return Api().post("map/generate", {
			data: {
				myData
			}
		});
	},

	getProviders(myData) {
		return Api().post("map/providers", {
			data: {
				myData
			}
		});
	},

	/**
	 * Cekame naupgrade tab
	 */

	startWatching(dataObj, ruianArr, userId) {
		return Api().post("upgrade/start", {
			data: {
				dataObj,
				ruianArr,
				userId
			}
		});
	},

	fetchWatching(userId) {
		return Api().get("upgrade/list", {
			params: {
				userId
			}
		});
	},

	fetchViable() {
		return Api().get("upgrade/viable");
	},

	removeWatch(id) {
		return Api().get("upgrade/remove", {
			params: {
				id
			}
		});
	},

	checkWatch(id) {
		return Api().get("upgrade/check", {
			params: {
				id
			}
		});
	},

	saveAdditionOnUpgrade(newPoznamka, id) {
		console.log({ newPoznamka });
		return Api().get("upgrade/poznamka/change", {
			params: {
				newPoznamka,
				id
			}
		});
	},

	/**
	 * Charts
	 * @param {*} pswd
	 * @param {*} user
	 */

	fetchChartData(from, to) {
		return Api().get("chart/fetch", {
			params: {
				from,
				to
			}
		});
	},

	fetchUpgradeChartData(from, to) {
		return Api().get("chart/upgrade/fetch", {
			params: {
				from,
				to
			}
		});
	},

	/**
	 * Pousteni dovnitr.
	 */

	authenticateUser(user) {
		return Api().get("auth", {
			params: {
				user
			}
		});
	},

	createTicket(user, text) {
		return Api().post("ticket/create", {
			data: {
				user,
				text
			}
		});
	},

	fetchTickets() {
		return Api().get("ticket/list");
	},

	ticketAction(action, id) {
		return Api().post("ticket/action", {
			data: {
				action,
				id
			}
		});
	},

	sendMail(str, fromMail, ruian) {
		console.log(str, fromMail);
		return Api().post("send-mail", { str, fromMail, ruian });
	}
};



// WEBPACK FOOTER //
// ./src/services/AdditionsService.js